import { useEffect } from 'react';

import { useAppDispatch } from '../../store/hooks';
import { listenerActions } from '../../store/listeners';

const ListenerContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(listenerActions.removeListeners());
    };
  }, [dispatch]);

  return null;
};

export default ListenerContainer;
